export default Object.freeze({
  FRANCE: 'France',
  MAROC: 'Maroc',
  TUNISIE: 'Tunisie',
  BELGIQUE: 'Belgique',
});
